import React from 'react';
import InputControl from '~/components/Input/InputControl';
import InputSelectAsync from '~/components/Input/InputSelectAsync';

import fetchAllCorporatePartnerWithParticular from '~/utils/fetchAllCorporatePartnerWithParticular';

function InputMultiCorporation({ corporation, setCorporation }) {
  return (
    <InputControl
      name={'corporation'}
      label={'Empresa'}
      value={corporation}
      inputComponent={InputSelectAsync}
      onChange={({ corporation: corp }) => {
        if (corp === null) {
          return setCorporation([
            {
              corporation_id: null,
              id: null,
              name: 'Todas',
            },
          ]);
        }

        if (corp[corp.length - 1]?.corporation_id === 0) {
          return setCorporation([
            {
              corporation_id: 0,
              id: 0,
              name: 'PARTICULAR',
            },
          ]);
        }

        if (
          (corp.length && corp[corp.length - 1].corporation_id === null) ||
          corp[corp.length - 1].corporation_id === 0
        ) {
          if (corp[corp.length - 1].corporation_id === null) {
            return setCorporation([
              {
                corporation_id: null,
                id: null,
                name: 'Todas',
              },
            ]);
          }
          return setCorporation([
            {
              corporation_id: 0,
              id: 0,
              name: 'PARTICULAR',
            },
          ]);
        }

        const validatePrivate =
          corp.length > 1 && corp.filter((item) => item.corporation_id === 0);

        if (validatePrivate.length === 1) {
          return setCorporation(
            corp.filter((item) => item.corporation_id !== 0)
          );
        }

        const validateAll =
          corp.length > 1 &&
          corp.filter((item) => item.corporation_id === null).length === 1;

        if (validateAll) {
          return setCorporation(
            corp.filter((item) => item.corporation_id !== null)
          );
        }

        setCorporation(corp);
      }}
      InputProps={{
        isClearable: false,
        handleFetch: fetchAllCorporatePartnerWithParticular,
        createEnabled: false,
        error: false,
        isMulti: true,
      }}
    />
  );
}

export default InputMultiCorporation;
